export const faqs = [
  {
    q: '「福利吃瓜」的内容多久更新一次？',
    a: '「今日上新」通常每天早晚各更新一轮，覆盖当天正在发酵的娱乐话题；「本周推荐」固定在每周一上新；「周末限定」与「假日特辑」则跟随档期上线。你可以在首页或瓜料库按档期查看全部内容。',
  },
  {
    q: '「今日上新」「本周推荐」有什么区别？',
    a: '「今日上新」追求时效，重点是当天发生、正在讨论的话题；「本周推荐」由编辑手工筛选，更看重内容是否值得花时间阅读，更新频率低但更耐看。两者配合使用，既不会错过热点，也不会被信息淹没。',
  },
  {
    q: '「周末限定」和「假日特辑」是怎么安排的？',
    a: '这两个栏目跟随档期上线。周末限定只在周五到周日的窗口内更新，假日特辑则围绕长假与节假日企划。如果你平时没时间追更，订阅档期提醒后可以在合适的时间集中查看。',
  },
  {
    q: '网站上的内容可以转载吗？',
    a: '我们欢迎合理引用与分享链接，但请注明来源为「吃瓜福利社」。如需整篇转载或用于商业用途，请先通过页脚邮箱与我们联系，我们会根据具体情况回复授权方式。',
  },
  {
    q: '如何订阅档期更新提醒？',
    a: '在首页底部的订阅区域留下你的邮箱即可。我们只会在上新与档期换挡时发送提醒，不会频繁打扰，你也可以随时通过邮件要求退订。',
  },
  {
    q: '我发现内容有误或想推荐选题，怎么反馈？',
    a: '可以通过页脚的邮箱联系我们，或在关于我们页面找到反馈入口。对于内容纠错，我们会在核实后尽快更新，并在页面底部标注修订说明。',
  },
];